import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 审批中心一级
const userRouter: RouteConfig = {
  path: '/feedback',
  component: Layout,
  redirect: '/feedback/feedback/feedback-list',
  meta: {
    title: '用户反馈',
    icon: 'menu-feedback',
    alwaysShowMenu: true
  },
  children: [
    {
      name: 'Feedback',
      path: 'feedback',
      component: () => import('@/views/feedback/feedback/index.vue'),
      redirect: '/feedback/feedback/feedback-list',
      meta: {
        title: '反馈管理'
      },
      children: [
        {
          name: 'FeedbackList',
          path: 'feedback-list',
          component: () => import('@/views/feedback/feedback/feedback-list.vue'),
          meta: {
            title: '反馈中心'
          }
        }
      ]
    }
  ]
}

export default userRouter
